export enum LookupType {
  'PATIENT' = 'PATIENT',
  'DOCTOR' = 'DOCTOR',
  'FACILITY' = 'FACILITY',
  'CONTACT' = 'CONTACT',
  'PRESCRIPTION' = 'PRESCRIPTION',
  'DRUG' = 'DRUG',
  'PHARMACY' = 'PHARMACY',
  'INSURANCE' = 'INSURANCE',
  'CLIENT' = 'CLIENT',
  'OFFICE' = 'OFFICE',
}
